import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  updateProfile(_, payload) {
    return axios.post('/api/profile', payload)
  },

  uploadAvatar(_, avatar) {
    const formData = new FormData()
    formData.append('avatar', avatar)

    return axios.post('/api/profile', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}
